module.exports = "<div class=\"container-fluid\"  >\n  <div class=\"row-fluid\">\n    <div class=\"row\">\n      <div class=\"col-sm-1\"></div>\n      <div class=\"col-sm-8 main-column\" style=\"background-color:lavender;\">\n        <div class=\"row\" style=\"text-align: center\">\n          <h2 >Ratings for restaurant {{restaurantName}}</h2>\n        </div>\n        <div class=\"row\">\n\n        </div>\n      </div>\n    </div>\n  </div>\n  </div>\n<div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/table/tables-raitings/tables-raitings.component.html
// module id = ./src/app/table/tables-raitings/tables-raitings.component.html
// module chunks = main